import { render, staticRenderFns } from "./WaterfallCard.vue?vue&type=template&id=1f5a2a27&scoped=true"
import script from "./WaterfallCard.vue?vue&type=script&lang=js"
export * from "./WaterfallCard.vue?vue&type=script&lang=js"
import style0 from "./WaterfallCard.vue?vue&type=style&index=0&id=1f5a2a27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5a2a27",
  null
  
)

export default component.exports